import { render, staticRenderFns } from "./TradeAccountUser.vue?vue&type=template&id=b72df92a&lang=pug"
import script from "./TradeAccountUser.vue?vue&type=script&lang=js"
export * from "./TradeAccountUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports